<template>
  <div class="popup-send-contact">

      <div class="u-popup-header">
        {{ $t('bookingPopup.popup.sandContact.title') }}
      </div>
      <div class="popup-send-contact__body">
        <div class="popup-send-contact__fio">
          <yt-input
            class="popup-send-contact__name"
            :label="$t('bookingPopup.popup.sandContact.name')"
            @input="changeField($event, 'name')"
            v-model="userContact.name"
            :value="userContact.name"
            :error="$v.userContact.name.$error"
            :hint="$v.userContact.name.$error ? $t('bookingPopup.popup.sandContact.error.name') : ''"
          />
          <yt-input
            class="popup-send-contact__lastname"
            :label="$t('bookingPopup.popup.sandContact.lastName')"
            @input="changeField($event, 'lastName')"
            v-model="userContact.lastName"
            :value="userContact.lastName"
            :error="$v.userContact.lastName.$error"
            :hint="$v.userContact.lastName.$error ? $t('bookingPopup.popup.sandContact.error.lastName') : ''"
          />
        </div>
        <yt-input
          class="popup-send-contact__email"
          label="E-mail"
          @input="changeField($event, 'email')"
          v-model="userContact.email"
          :value="userContact.email"
          :error="$v.userContact.email.$error"
          :hint="$v.userContact.email.$error ? $t('bookingPopup.popup.sandContact.error.email') : ''"
        />
        <yt-input
          class="popup-send-contact__phone"
          type="phone"
          ref="phone"
          v-model="userContact.phone"
          :value="userContact.phone"
          @input="changeField($event, 'phone')"
          :error="$v.userContact.phone.$error"
          :hint="getPhoneErrorText"
        />
        <yt-button
          class="popup-send-contact__submit"
          color="green"
          @click="submitPopup"
        >
          {{$t('bookingPopup.popup.sandContact.btn')}}
        </yt-button>
        <div class="u-popup-note" >
          {{$t('bookingPopup.popup.termsBooking.text1')}}
          <a href="/help/public-offer" target="_blank">{{$t('bookingPopup.popup.termsBooking.textOffer')}}</a>
          {{$t('bookingPopup.popup.termsBooking.text2')}}
          <a href="/help/privacy-agree" target="_blank">
          {{$t('bookingPopup.popup.termsBooking.textPrivacy')}}
          </a>
        </div>
      </div>


  </div>
</template>

<script>

import YtInput from "@/components/ui-kit/yt-input";
import YtButton from "@/components/ui-kit/yt-button"
import {minLength, required, email} from "vuelidate/lib/validators";
export default {
  components: {
     YtInput,
     YtButton,
  },
  data() {
    return {
      mounted: false,
      userContact: {
        phone: "",
        email: "",
        name: "",
        lastName: ""
      },
    }
  },
  props: {
    userData: {
      type: Object
    }
  },
  validations: {
    userContact: {
      phone: {
        required,
        minLength(value) {
          if (value.replaceAll(' ', '').replaceAll('+', '').length >= 10) {
            return true;
          }
          return false;
        },
      },
      email: {
        required,
        email,
      },
      name: {
        required,
        minLength: minLength(3),
      },
      lastName: {
        required,
        minLength: minLength(3),
      }
    }
  },
  computed: {
    getPhoneErrorText() {
      if(this.$v.userContact.phone.$error) {
        if(this.userContact.phone.replaceAll(' ', '').replaceAll('+', '').length <=3) {
          return this.$t('bookingPopup.popup.sandContact.error.phone')
        }
        return this.$t('auth.initial.wrongPhone')
      }
      return ''
    }
  },
  methods: {
    changeField(evt, field) {
      if(!this.mounted && field == "phone") {
        if(this.userData[field]) {
          const value = '+'+this.userData[field].replaceAll('+', '')
          this.userContact[field] = value;
        }
        this.mounted = true;
        return;
      }
      this.userContact[field] = evt;
    },
    async submitPopup() {
      this.$v.$touch();

      if(this.$v.userContact.$error) {
        return;
      }
     this.$emit('send-contact-submit', {popup: 'send-contact', value: this.userContact});
    }
  },
  mounted() {
    this.userContact = {
      ...this.userData
    }
    this.$emit('loaded');
  }
}
</script>

<style  lang="scss" scoped>
.popup-send-contact{
  padding: 8px;
  &__fio{
    display: flex;
   }
  &__name {
    & >>> .yt_input-container {
      border-radius: 8px 0 0 8px;
    }
  }
  &__lastname{
    & >>> .yt_input-container {
      border-radius: 0 8px 8px 0;
      border-left: none;

      &:focus-within {
        border-left: 1px solid var.$black;
      }
    }
  }
  &__lastname.yt_input--error{
    & >>> .yt_input-container {
      border-radius: 0 8px 8px 0;
      border-left: none;
      border-left: 1px solid var.$red!important;
      margin: 0 0 0 -1px;
    }
  }
  &__fio, &__email, &__phone {
    margin-bottom: 20px;
    width: 100%;
  }

  &__submit{
    width: 100%;
    margin-bottom: 16px;
  }
}
.popup-send-contact .yt_input {
  width: 100%;
}
.u-popup-note a {
  color: inherit!important;
  text-decoration: underline;
}
</style>
